import { FormAlert } from "@NP-Webber/crm-kit";
import {
  AccountingSection,
  BankSection,
  DocumentsSection,
  PaymentRequestsSection,
  ReceiptsSection,
  SuppliersSection,
} from "./AuxSections";
import { hasFeature, type CashLedgerSection } from "./cashLedgerUtils";
import { LedgerSections } from "./LedgerSections";

export type { CashLedgerSection } from "./cashLedgerUtils";

export type IncomeExpensesPanelProps = {
  customerId: string | null;
  customerIds: string[];
  customerNames: Record<string, string>;
  writeCustomerId: string;
  archived: boolean;
  enabledFeatures: readonly string[];
  section?: CashLedgerSection;
};

export function IncomeExpensesPanel({
  customerId,
  customerIds,
  customerNames,
  writeCustomerId,
  archived,
  enabledFeatures,
  section = "ledger",
}: IncomeExpensesPanelProps) {
  const cashEnabled = hasFeature(enabledFeatures, "finance.cash_ledger");
  const base = {
    customerId,
    customerIds,
    customerNames,
    writeCustomerId,
    archived,
  };

  if (!cashEnabled) {
    return (
      <div className="related-panel">
        <FormAlert severity="info">מודול הכנסות והוצאות אינו מופעל לארגון זה.</FormAlert>
      </div>
    );
  }

  if (section === "ledger") {
    return <LedgerSections {...base} />;
  }
  if (section === "suppliers" && hasFeature(enabledFeatures, "finance.suppliers")) {
    return <SuppliersSection {...base} />;
  }
  if (
    section === "payment_requests" &&
    hasFeature(enabledFeatures, "finance.payment_requests")
  ) {
    return <PaymentRequestsSection {...base} />;
  }
  if (section === "documents" && hasFeature(enabledFeatures, "finance.documents")) {
    return <DocumentsSection {...base} />;
  }
  if (section === "receipts" && hasFeature(enabledFeatures, "finance.receipts")) {
    return <ReceiptsSection {...base} />;
  }
  if (section === "bank" && hasFeature(enabledFeatures, "finance.bank_reconciliation")) {
    return <BankSection {...base} />;
  }
  if (
    section === "accounting" &&
    hasFeature(enabledFeatures, "finance.accounting_documents")
  ) {
    return <AccountingSection {...base} />;
  }

  return (
    <FormAlert severity="info">הפיצ׳ר אינו מופעל לארגון זה.</FormAlert>
  );
}
